import { SVGProps } from 'react'

export function HouseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 53 53"
      width={53}
      height={53}
      className="h-12 w-12 fill-current"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        d="M27.384 36.238H26.5c-.53 0-.883.354-.883.884s.354.883.883.883h.884c.53 0 .883-.353.883-.883s-.353-.884-.883-.884Z"
      />
      <path
        fill="currentColor"
        d="M52.117 18.572H37.1v-1.767c0-.353-.177-.618-.442-.795L18.992 5.41a.802.802 0 0 0-.884 0L.442 16.01c-.265.177-.442.442-.442.795v4.417c0 .353.177.618.442.795a.802.802 0 0 0 .883 0l1.325-.795v25.616c0 .53.353.884.883.884H50.35c.53 0 .883-.354.883-.884v-21.2h.884c.53 0 .883-.353.883-.883v-5.3c0-.53-.353-.883-.883-.883Zm-21.2 25.616h1.766v1.767h-1.766v-1.767Zm3.533-7.066h11.483v1.766H34.45v-1.766Zm11.483-1.767H34.45v-1.767h11.483v1.767Zm-11.483 5.3h11.483v1.767H34.45v-1.767Zm11.483-8.833H34.45v-1.767h11.483v1.767ZM1.767 17.335 18.55 7.265l16.783 9.982V19.632L18.992 9.827a.251.251 0 0 0-.103-.058.806.806 0 0 0-.678 0 .251.251 0 0 0-.103.058l-15.017 9.01c-.099.066-.186.145-.256.236l-1.069.647v-2.385Zm30.916 2.827V42.422h-1.766V27.405c0-.53-.354-.883-.884-.883h-10.6c-.53 0-.883.353-.883.883v15.017H4.417v-22.26l14.133-8.48 14.133 8.48ZM4.417 44.188H18.55v1.767H4.417v-1.767Zm15.9 1.767V28.288h8.833v17.667h-8.833Zm14.133 0v-1.767h11.483v1.767H34.45Zm15.017 0H47.7V29.172c0-.53-.353-.884-.883-.884H34.45v-2.65h15.017v20.317Zm1.766-22.083H34.45v-2.65l1.325.795a.25.25 0 0 0 .103.057.803.803 0 0 0 .78-.057c.265-.177.442-.442.442-.795v-.884h14.133v3.534Z"
      />
      <path
        fill="currentColor"
        d="M6.184 37.123H16.784c.53 0 .883-.353.883-.883s-.353-.883-.883-.883v-7.95c0-.53-.353-.884-.883-.884H7.067c-.53 0-.883.354-.883.884v7.95c-.53 0-.883.353-.883.883s.353.883.883.883Zm6.183-1.766v-2.65h2.65v2.65h-2.65Zm2.65-4.417h-2.65v-2.65h2.65v2.65Zm-4.416-2.65v2.65H7.95v-2.65h2.65Zm-2.65 4.417h2.65v2.65H7.95v-2.65Z"
      />
    </svg>
  )
}

export default HouseIcon
